import { eventFactoryCollection } from '../event-factory'
import { initGTM, initGTMDataLayer, sendGTMEvent, setupUTMs } from './helpers'
import type { AnalyticsEventName, AnalyticsVendor } from '@/tools/analytics/types'
import { getConfig } from '@/tools/config'
import { serviceConsentCategory } from '@/tools/cookies-blocker/service/constants'
import type { CookieCategory } from '@/tools/cookies-blocker/types'

export class GoogleTagManager implements AnalyticsVendor {
  public name = 'GoogleTagManager'
  public consentCategory: CookieCategory = serviceConsentCategory.googleTagsManager
  public isInitialized = false

  public canHandle = (eventName: AnalyticsEventName) =>
    Object.keys(eventFactoryCollection).includes(eventName)

  public async init() {
    const { googleTagManagerId, env } = getConfig()
    const isDevelomentState = env === 'development'

    // 1. Initialize GTM dataLayer
    initGTMDataLayer()
    // 2. Initialize GTM script and inject it to the page
    await initGTM(googleTagManagerId, isDevelomentState)
    // 3. Setup UTMs params to dataLayer if they exist in the URL
    setupUTMs()

    this.isInitialized = true
  }

  public trackEvent<EVENT_NAME extends AnalyticsEventName>(eventName: EVENT_NAME) {
    const factoryMethod = eventFactoryCollection[eventName as keyof typeof eventFactoryCollection]
    const eventInstance = factoryMethod()
    sendGTMEvent(eventInstance)
  }
}
